module.exports = __webpack_public_path__ + "img/New PACI Flow - New-11.06177cab.png";